import {
  mdiCloseCircle,
  mdiArrowUpCircleOutline,
  mdiArrowDownCircleOutline,
  mdiCheckboxBlankCircle,
  mdiInformationOutline,
  mdiCheckCircle,
  mdiChevronDown,
  mdiFilterVariant,
  mdiPencilOutline,
  mdiDeleteOutline,
  mdiWindowClose,
  mdiMagnify,
  mdiPlus,
  mdiDotsVertical,
  mdiNoteTextOutline,
  mdiMoveResizeVariant,
  mdiCheckboxMarkedCircleOutline,
  mdiHammerScrewdriver,
  mdiFilePdf,
  mdiFileExcel,
  mdiSwapVertical,
  mdiBottleWine,
  mdiLoading,
  mdiArrowLeftCircleOutline,
  mdiArrowRightCircleOutline,
  mdiArrowRight,
  mdiAlert,
  mdiEye,
  mdiEyeOff,
  mdiFileDocumentOutline,
  mdiClipboardText,
  mdiChartLine,
  mdiCashRegister,
  mdiCloseCircleOutline,
  mdiArrowDownThick,
  mdiArrowLeft,
  mdiLogin,
  mdiClockOutline,
  mdiLaptop,
  mdiFood,
  mdiCalendar,
  mdiLogout,
  mdiCogs,
  mdiCogOutline,
  mdiAccountGroupOutline,
  mdiCalendarBlank,
  mdiChevronUp,
  mdiTagOutline,
  mdiFactory,
  mdiTag,
  mdiCashMultiple,
  mdiCalendarRange,
  mdiMenu,
  mdiArchiveArrowDownOutline,
  mdiArchiveArrowUpOutline,
  mdiReceipt,
  mdiAccountOutline,
  mdiCloudOutline,
  mdiHelpCircleOutline,
  mdiAlertCircle,
  mdiCheck,
  mdiAlertOutline,
  mdiFilterOutline,
  mdiShopping,
  mdiTagPlus,
  mdiCancel,
  mdiPaperclip,
  mdiCurrencyUsd,
  mdiEmailOutline,
  mdiEmailOpenOutline,
  mdiEmailNewsletter,
  mdiBellOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiKeyOutline,
  mdiCashRefund,
  mdiNote,
  mdiSend,
  mdiPrinter,
  mdiMapMarkerOutline,
  mdiContentCopy,
  mdiStarOutline,
  mdiFormatListBulleted,
  mdiFileChartOutline,
  mdiGridLarge,
  mdiRocketOutline,
  mdiAccountCircleOutline,
  mdiChartBar,
  mdiSale,
  mdiAccountGroup,
  mdiCalendarClockOutline,
  mdiPackageVariant,
  mdiEmoticonOutline,
  mdiXml,
  mdiStar,
  mdiQrcode,
  mdiBarcode,
  mdiCreditCard,
  mdiCheckCircleOutline,
  mdiLinkVariant,
  mdiRefresh,
  mdiPizza,
  mdiShapeOutline 
} from '@mdi/js'

export const format = {
  methods: {
    /**
     * RETORNA AS INICIAIS DO NOME
     */

    getInitials(name) {
      if (!name) return ''
      const names = name.split(' ')
      if (names.length >= 2) {
        return (names[0][0] + names[1][0]).toUpperCase()
      }

      return name.substring(0, 2).toUpperCase()
    },

    /**
     *
     * @param {*} value // valor a ser formatado
     * @param {*} show // indica se deve mostrar o valor ou ocultar
     * @returns
     */
    formatMoney(value, show = true) {
      if (show == true) {
        if (value != null) {
          value = parseFloat(value)

          return value.toLocaleString('pt-br', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        }

        return '0,00'
      }

      return '••••'
    },
    parseDateValue(value) {
      if (!value) return null
      if (value instanceof Date) return value

      if (typeof value === 'string') {
        // Mantem datas sem horario no dia correto em fusos negativos (ex.: America/Sao_Paulo)
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          const [year, month, day] = value.split('-').map(Number)

          return new Date(year, month - 1, day, 12, 0, 0)
        }

        // Alguns backends enviam meia-noite UTC para campos de data; normaliza para data local
        if (/^\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?Z$/.test(value)) {
          const [year, month, day] = value.split('T')[0].split('-').map(Number)

          return new Date(year, month - 1, day, 12, 0, 0)
        }
      }

      return new Date(value)
    },
    formatDateString(date) {
      if (date) {
        const result = this.parseDateValue(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            day: '2-digit',

            // month: 'long',
            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            month: 'short',

            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            // month: 'short',
            year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })}`
        )
      }
    },
    formatDateTimeString(date) {
      if (date) {
        const result = this.parseDateValue(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            day: '2-digit',

            // month: 'long',
            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            month: 'short',

            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            // month: 'short',
            year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' })}`
        )
      }
    },
    formatDateTimePrecisionString(date) {
      if (date) {
        const result = this.parseDateValue(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            day: '2-digit',

            // month: 'long',
            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            month: 'short',

            // year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleDateString('pt-BR', {
            // day: '2-digit',
            // month: 'short',
            year: 'numeric',
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'America/Sao_Paulo',
          })}`
        )
      }
    },
    formatDateTime(date) {
      if (date) {
        const result = this.parseDateValue(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo',
          })
          } ${result.toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`
        )
      }
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = this.parseDateValue(dateString)

      return date
        .toLocaleDateString('pt-BR', {
          timeZone: 'America/Sao_Paulo',
        })
        .replace(/ de /g, ' ')
    },
    formatDateYearShort(dateString) {
      if (!dateString) return ''
      const date = this.parseDateValue(dateString)

      return date
        .toLocaleDateString('pt-BR', {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'America/Sao_Paulo',
        })
        .replace(/ de /g, ' ')
    },

    formatDateLong(dateString) {
      if (!dateString) return ''
      const date = this.parseDateValue(dateString)

      const weekdays = [
        'domingo',
        'segunda-feira',
        'terça-feira',
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        'sábado',
      ]
      const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']

      const weekday = weekdays[date.getDay()]
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()

      return `${weekday}, ${day} ${month} ${year}`
    },

    formatTime(time) {
      if (!time) return '0min'
      const [hours, minutes] = time.split(':').map(Number)
      const totalMinutes = hours * 60 + minutes
      const d = Math.floor(totalMinutes / (24 * 60))
      const h = Math.floor((totalMinutes % (24 * 60)) / 60)
      const m = totalMinutes % 60
      let result = ''
      if (d > 0) {
        result += `${d}d `
      }
      if (h > 0) {
        result += `${h}h `
      }
      if (m > 0) {
        result += `${m}min`
      }

      return result.trim() || '0min'
    },
  },
}

export const validations = {
  methods: {
    /**
     * valida se tem uma letra maiúscula,
     * uma letra minúscula,
     * um número e um caractere especial
     * @param {*} password
     * @returns
     */
    validationPassword(password) {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

      return re.test(password)
    },
    validateEmail(email) {
      const re = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/

      return re.test(email)
    },
  },
}

export const icons = {
  data() {
    return {
      icons: {
        mdiCloseCircle,
        mdiArrowUpCircleOutline,
        mdiCheckboxBlankCircle,
        mdiArrowDownCircleOutline,
        mdiInformationOutline,
        mdiCheckCircle,
        mdiChevronDown,
        mdiFilterVariant,
        mdiPencilOutline,
        mdiDeleteOutline,
        mdiWindowClose,
        mdiMagnify,
        mdiPlus,
        mdiDotsVertical,
        mdiNoteTextOutline,
        mdiMoveResizeVariant,
        mdiCheckboxMarkedCircleOutline,
        mdiHammerScrewdriver,
        mdiFilePdf,
        mdiFileExcel,
        mdiSwapVertical,
        mdiBottleWine,
        mdiLoading,
        mdiArrowLeftCircleOutline,
        mdiArrowRightCircleOutline,
        mdiAlert,
        mdiEye,
        mdiEyeOff,
        mdiFileDocumentOutline,
        mdiClipboardText,
        mdiChartLine,
        mdiCashRegister,
        mdiCloseCircleOutline,
        mdiArrowDownThick,
        mdiArrowLeft,
        mdiClockOutline,
        mdiLogin,
        mdiCheckboxMarkedCircleOutline,
        mdiLaptop,
        mdiFood,
        mdiCalendar,
        mdiLogout,
        mdiCogs,
        mdiCogOutline,
        mdiAccountGroupOutline,
        mdiCalendarBlank,
        mdiChevronUp,
        mdiTagOutline,
        mdiFactory,
        mdiTag,
        mdiCashMultiple,
        mdiCalendarRange,
        mdiMenu,
        mdiArchiveArrowDownOutline,
        mdiArchiveArrowUpOutline,
        mdiReceipt,
        mdiCloudOutline,
        mdiHelpCircleOutline,
        mdiAccountOutline,
        mdiArrowLeft,
        mdiCheck,
        mdiAlertCircle,
        mdiAlertOutline,
        mdiFilterOutline,
        mdiArrowRight,
        mdiShopping,
        mdiTagPlus,
        mdiCancel,
        mdiPaperclip,
        mdiCurrencyUsd,
        mdiEmailOutline,
        mdiEmailOpenOutline,
        mdiEmailNewsletter,
        mdiBellOutline,
        mdiChevronLeft,
        mdiChevronRight,
        mdiKeyOutline,
        mdiCashRefund,
        mdiNote,
        mdiSend,
        mdiPrinter,
        mdiMapMarkerOutline,
        mdiContentCopy,
        mdiStarOutline,
        mdiFormatListBulleted,
        mdiFileChartOutline,
        mdiGridLarge,
        mdiRocketOutline,
        mdiAccountCircleOutline,
        mdiChartBar,
        mdiSale,
        mdiCurrencyUsd,
        mdiAccountGroup,
        mdiCalendarClockOutline,
        mdiPackageVariant,
        mdiEmoticonOutline,
        mdiChartLine,
        mdiStar,
        mdiXml,
        mdiQrcode,
        mdiBarcode,
        mdiCreditCard,
        mdiCheckCircleOutline,
        mdiLinkVariant,
        mdiRefresh,
        mdiPizza,
        mdiShapeOutline
      },
    }
  },
}
